import MobileContactMain from "@/components/ContactModal/mobile/components/Main";
import styles from "./index.module.less";
const MobileContactPage = () => {
    return <div className={styles.contact}>
        <MobileContactMain />
    </div>;
};
export default MobileContactPage;